module.exports = __webpack_public_path__ + "img/pr-1.0f2cdc83.png";